import { useMemo, useState } from "react";
import CollapseItem from "../../../components/CollapseItem";
import FieldsOptions from "./FieldsOptions";
import FieldsSettings from "./FieldsSettings";
import { Button } from "reactstrap";
import { CheckPicker } from "rsuite";
import { FormBuilder } from "../../../../../types/FormBuilderInterfaces";
import { Prefill } from "../../../../../types/GlobalInterfaces";
import { FormAvailableFields } from "../../../FormBuilderDrawer";

interface Props {
  form: FormBuilder;
  setForm: (value: any, key: string) => void;
  availableOptions: FormAvailableFields[];
  prefill?: Prefill;
}

const Fields = ({ form, setForm, availableOptions, prefill }: Props) => {
  const [addFieldOpen, setAddFieldOpen] = useState<boolean>(false);

  const fieldCollapse = useMemo(() => {
    if (!form.Fields || Object.keys(form.Fields).length < 1) return [];

    return Object.keys(form.Fields).map((item) => {
      if (!form.Fields?.[item]) {
        return;
      }
      const fieldKey = form.Fields[item];

      if (!fieldKey.Field) return;

      return {
        key: fieldKey.Field.APIName,
        title: fieldKey.Field.Name,
        children: (
          <FieldsSettings
            form={form}
            setForm={setForm}
            field={fieldKey.Field}
            prefill={prefill}
          />
        ),
        optionMenu: (
          <FieldsOptions form={form} setForm={setForm} field={fieldKey.Field} />
        ),
      };
    });
  }, [form]);

  return (
    <>
      {!!fieldCollapse.length &&
        fieldCollapse?.map((field) => {
          if (!field) return;
          return (
            <CollapseItem
              title={field.title}
              children={field.children}
              optionMenu={field.optionMenu}
              key={field.key}
              defaultOpen={false}
            />
          );
        })}
      <Button
        className="mt-2"
        outline
        onClick={() => setAddFieldOpen(!addFieldOpen)}
      >
        {addFieldOpen ? "Hide Select" : "+ Add Field"}
      </Button>
      {addFieldOpen && (
        <CheckPicker
          data={availableOptions}
          placeholder="Select Fields"
          cleanable
          onSelect={(_, item) => {
            const formFields = form.Fields || {};
            const fieldAPIName = item.value;
            const field = item.item;

            if (!field || !fieldAPIName) return;

            // Remove field if it already exists in form.
            if (formFields[fieldAPIName]) {
              delete formFields[fieldAPIName];
              return setForm({ ...formFields }, "Fields");
            }

            formFields[fieldAPIName] = {
              Field: field,
              Settings: {
                Label: field.Name,
                Placeholder: field.Name,
                Default: field.Default,
                Required: false,
                Match: false,
              },
            };

            setForm({ ...formFields }, "Fields");
          }}
          className="mt-2"
          block
          value={form.Fields ? Object.keys(form.Fields) : []}
          preventOverflow
        />
      )}
    </>
  );
};

export default Fields;
